import {
  Component,
  ChangeDetectionStrategy,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { ProcessService } from './features/process/services/process.service';
import { LoginComponent } from './features/auth/login/login.component';
import { CUSTOM_ELEMENTS_SCHEMA } from '@angular/core'; // Betha
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule, MatSidenav } from '@angular/material/sidenav';
import { HeaderComponent } from './shared/components/header/header.component';
import { SidebarComponent } from './shared/components/sidebar/sidebar.component';
import { CommonModule, NgIf } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { SwUpdate } from '@angular/service-worker';
import { AuthService } from './core/services/AuthService/auth.service';
import { StorageService } from './core/services/StorageService/storage-service.service';
import { distinctUntilChanged } from 'rxjs/internal/operators/distinctUntilChanged';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    RouterOutlet,
    LoginComponent,
    MatSidenavModule,
    MatToolbarModule,
    MatIconModule,
    MatButtonModule,
    HeaderComponent,
    SidebarComponent,
    CommonModule,
    NgIf,
    HttpClientModule,
  ],
  templateUrl: './app.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AppComponent {
  title = 'arbor-frontend';
  currentTheme: string | null = null;
  username: string = '';

  @ViewChild('sidenav') sidenav!: MatSidenav;
  isSidebarOpen = true;

  constructor(
    private swUpdate: SwUpdate,
    private processService: ProcessService,
    private authService: AuthService,
    private storageService: StorageService,
    private router: Router,
    private renderer: Renderer2
  ) {
    // Verificação e atualização do Service Worker
    if (this.swUpdate.isEnabled) {
      this.swUpdate.versionUpdates.subscribe((event) => {
        if (event.type === 'VERSION_READY') {
          if (confirm('Nova versão disponível. Deseja atualizar?')) {
            window.location.reload();
          }
        }
      });
    } else {
      console.log('Service worker updates are not enabled.');
    }

    // Adiciona o listener para o evento de logout
    this.authService.logoutEvent.subscribe(() => {
      this.handleLogout();
    });
  }

  async ngOnInit() {
    if (this.processService.syncProcesses) {
      window.addEventListener('online', () => {
        this.processService.syncProcesses();
      });
    }
  
    const user = await this.authService.getUser();
    if (user) {
      const userProfile = await this.authService.getUserProfile(user.email);
      if (userProfile) {
        this.username = userProfile.firstName || 'Usuário'; // Define o username
      }
    }
  
    this.authService.authStatus.pipe(distinctUntilChanged()).subscribe(async (isAuthenticated) => {
      console.log('Auth status changed:', isAuthenticated);
      if (isAuthenticated) {
        const user = await this.authService.getUser();
        console.log('Authenticated user:', user);
        await this.applyUserTheme();
      } else {
        this.clearThemeSetting();
      }
    });
  }

  toggleSidebar() {
    if (this.sidenav) {
      this.sidenav.toggle();
    }
  }

  shouldShowSidebarAndHeader(): boolean {
    const currentRoute = this.router.url;
    console.log('Current route:', currentRoute, 'Show sidebar:', currentRoute !== '/login');
    return currentRoute !== '/login';
  }

  // Aplica o tema com base no usuário logado
  async applyUserTheme() {
    console.log("Aplicando tema...");
    const user = await this.authService.getUser();
    console.log("Usuário recuperado:", user);
    if (user) {
      const userProfile = await this.authService.getUserProfile(user.email);
      console.log("Perfil do usuário:", userProfile);
  
      if (userProfile && userProfile.theme && this.currentTheme !== userProfile.theme) {
        this.username = userProfile.firstName || 'Usuário';
        console.log("Aplicando tema:", userProfile.theme);
        this.applyTheme(userProfile.theme);
      }
    }
  }

  // Aplica o tema ao documento
  applyTheme(theme: string) {
    if (this.currentTheme) {
      this.renderer.removeClass(document.body, this.currentTheme);
    }
    this.renderer.addClass(document.body, theme);
    this.currentTheme = theme;
    this.storageService.setTheme(theme);
  }

  logout(): void {
    this.clearThemeSetting();
    this.authService.logout();
    this.router.navigate(['./login']); // Redireciona para a tela de login
  }

  handleLogout() {
    this.clearThemeSetting();
    this.router.navigate(['./login']);
  }

  clearThemeSetting(): void {
    if (this.currentTheme) {
      this.renderer.removeClass(document.body, this.currentTheme);
    }
    this.currentTheme = null;
    this.storageService.removeTheme();
    console.log('Configuração de tema removida.');
  }
}
